/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Launcher_TitleInputs */

const en_pc_dl_launcher_title = /** @type {(inputs: Pc_Dl_Launcher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer automatic updates?`)
};

const zh_pc_dl_launcher_title = /** @type {(inputs: Pc_Dl_Launcher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想要自动更新？`)
};

/**
* | output |
* | --- |
* | "Prefer automatic updates?" |
*
* @param {Pc_Dl_Launcher_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_launcher_title = /** @type {((inputs?: Pc_Dl_Launcher_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Launcher_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_launcher_title(inputs)
	return zh_pc_dl_launcher_title(inputs)
});
export { pc_dl_launcher_title as "pc.dl.launcher_title" }